import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import UserForm from "./UserForm";

export default function EditUser({ name }) {
    return (
        <CustomCard title={name}>
            <UserForm type="EDIT" />
        </CustomCard>
    );
}
